import notebookRouterPaths from './notebookRouterPaths';

export default notebookRouterPaths;
